import { translate } from "../../../../config/localisation";
import {

  ThemeProvider,

} from "@mui/material";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";

import React, { useEffect, useState } from "react";
import Header from "../../component/common/Header";
import themeDefault from "../../../theme/theme";
import { Link, useNavigate, useParams } from "react-router-dom";
import Button from "../../component/common/Button";
import OutlinedTextField from "../../component/common/OutlinedTextField";
import Spinner from "../../component/common/Spinner";
import CustomizedSnackbars  from "../../component/common/Snackbar";
import DatasetStyle from "../../../styles/Dataset";
import { useDispatch, useSelector } from "react-redux";
import APITransport from "../../../../redux/actions/apitransport/apitransport";
import CreateNewDatasetInstanceAPI from "../../../../redux/actions/api/Dataset/CreateNewDatasetInstance";
import GetDatasetTypeAPI from "../../../../redux/actions/api/Dataset/GetDatasetType"
import MenuItems from "../../component/common/MenuItems"
import configs from "../../../../config/config";
import { Info } from "@mui/icons-material";

const CollectionProject = (props) => {
  const { id } = useParams();
  const navigate = useNavigate();
  const classes = DatasetStyle();
  const dispatch = useDispatch();
  const [instance_Name, setInstance_Name] = useState("")
  const [parent_Instance_Id, setParent_Instance_Id] = useState(null)
  const [instance_Description, setInstance_Description] = useState("")
  const [organisation_Id, setOrganisation_Id] = useState("")
  const [users, setUsers] = useState("")
  const [datasettype, setDatasettype] = useState("");
  const [type, setType] = useState([]);
  const [loading, setLoading] = useState(false);
  const [snackbarState, setSnackbarState] = useState({ open: false, message: "", variant: ""});
  const [errors, setErrors] = useState({});

  const loggedInUserData = useSelector(
    (state) => state.fetchLoggedInUserData.data
  );

  // Владелец датасета — тот, кто его создаёт; отдельного поля в форме нет.
  useEffect(() => {
    if (loggedInUserData?.id) setUsers([loggedInUserData.id]);
  }, [loggedInUserData?.id]);

  // Список организаций вместо ручного ввода числового id.
  const [organisationOptions, setOrganisationOptions] = useState([]);
  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await fetch(`${configs.BASE_URL_AUTO}/organizations/`, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `JWT ${localStorage.getItem("csi_access_token")}`,
          },
        });
        const body = await res.json();
        // ответ пагинирован: список лежит в results
        const list = Array.isArray(body) ? body : body?.results;
        if (cancelled || !res.ok || !Array.isArray(list)) return;
        setOrganisationOptions(
          list.map((org) => ({ name: org.title, value: org.id }))
        );
        // одна организация — выбираем её сразу, выбирать не из чего
        if (list.length === 1) setOrganisation_Id(list[0].id);
        else if (loggedInUserData?.organization?.id) {
          setOrganisation_Id(loggedInUserData.organization?.id);
        }
      } catch (e) {
        // список не загрузился — поле останется пустым, форма не ломается
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [loggedInUserData?.organization?.id]);

  const handleCreate = () => {
    setLoading(true);
    setErrors({});
    const CreateDatasetInstance = {
      instance_name: instance_Name,
      parent_instance_id: parent_Instance_Id,
      instance_description: instance_Description,
      dataset_type: datasettype,
      organisation_id: organisation_Id,
      users: users,
    }
    const apiObj = new CreateNewDatasetInstanceAPI(CreateDatasetInstance);
    fetch(apiObj.apiEndPoint(), {
      method: "POST",
      body: JSON.stringify(apiObj.getBody()),
      headers: apiObj.getHeaders().headers,
    }).then(async (res) => {
      if (!res.ok) throw await res.json();
      else return await res.json();
    }).then((res) => {
      setLoading(false);
      navigate(`/datasets/${res.instance_id}`);
    }).catch((err) => {
      setErrors(err);
      setSnackbarState({ open: true, message: "Failed to create dataset instance", variant: "error" });
      setLoading(false);
    });
  }

  const datasetType = useSelector(state => state.GetDatasetType.data);

  const getProjectDetails = () => {
    const projectObj = new GetDatasetTypeAPI(id);
    dispatch(APITransport(projectObj));
  }

  useEffect(() => {
    getProjectDetails();

  }, []);

  useEffect(() => {
    if (datasetType && datasetType.length > 0) {
      let temp = [];
      datasetType.forEach((element) => {
        temp.push({
        
          name: element,
          value: element,

        });
      });
      setType(temp);
    }
  }, [datasetType]);

  const renderSnackBar = () => {
    return (
      <CustomizedSnackbars
          open={snackbarState.open}
          handleClose={() => setSnackbarState({ open: false, message: "", variant: "" })}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          variant={snackbarState.variant}
          message={snackbarState.message}
      />
    );
};

  console.log(loggedInUserData,"loggedInUserData")
  return (
    <ThemeProvider theme={themeDefault}>
      {/* <Header /> */}
      {/* <Grid
                  container
                  direction='row'
                  justifyContent='left'
                  alignItems='left'
  
  
              >
                  <Grid
                      item
                      xs={5}
                      sm={5}
                      md={5}
                      lg={5}
                      xl={5}
                  > */}

      <Grid container direction="row"  >
        {loading && <Spinner /> }
        <Card className={classes.workspaceCard}>
          <Grid item xs={2} sm={2} md={2} lg={2} xl={2}></Grid>
          <Grid item xs={8} sm={8} md={8} lg={8} xl={8} sx={{ pb: "6rem" }}>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <Typography variant="h2" gutterBottom component="div">
              {translate("Create New Dataset Instance")}
              </Typography>
            </Grid>
            <Grid
              className={classes.projectsettingGrid}
              xs={12}
              sm={12}
              md={12}
              lg={12}
              xl={12}
            >
              <Typography gutterBottom component="div">
                Instance_Name: <span style={{color:"red"}}>*</span>
              </Typography>
            </Grid>
            <Grid item xs={12} md={12} lg={12} xl={12} sm={12}>
              <OutlinedTextField
                fullWidth
                value={instance_Name}
                onChange={(e) => setInstance_Name(e.target.value)}
                required
                helperText={errors.instance_name ? errors.instance_name : ""}
                error={errors.instance_name ? true : false}
              />
            </Grid>
            <Grid
              className={classes.projectsettingGrid}
              xs={12}
              sm={12}
              md={12}
              lg={12}
              xl={12}
            >
             <Grid item xs={4} md={4} lg={4} xl={4} sm={4}>
  <div style={{ display: 'flex', alignItems: 'center' }}>
    <Typography gutterBottom component="div">
      Parent_Instance_Id:
    </Typography>
    <Tooltip 
    arrow
      title="Parent Data (A reference to database object referenced by integer ID field) - The parent data item id of this record. When a single sentence in a particular language is to be translated into another language, the source data item id is used as a 'Parent Data' and a separate child conversation data item is created for each language for which the source data item is to be translated into." 
      placement="right"
    >
      <Info style={{ marginBottom: "5px", cursor: 'pointer', color: "grey" }} />
    </Tooltip>
  </div>
</Grid>

            </Grid>
            <Grid item xs={12} md={12} lg={12} xl={12} sm={12}>
              <OutlinedTextField
                fullWidth
                value={parent_Instance_Id}
                onChange={(e) => setParent_Instance_Id(e.target.value)}
                helperText={errors.parent_instance_id ? errors.parent_instance_id : ""}
                error={errors.parent_instance_id ? true : false}
              />
            </Grid>
            <Grid
              className={classes.projectsettingGrid}
              xs={12}
              sm={12}
              md={12}
              lg={12}
              xl={12}
            >
              <Typography gutterBottom component="div">
                Instance_Description:
              </Typography>
            </Grid>
            <Grid item xs={12} md={12} lg={12} xl={12} sm={12}>
              <OutlinedTextField
                fullWidth
                value={instance_Description}
                onChange={(e) => setInstance_Description(e.target.value)}
                helperText={errors.instance_description ? errors.instance_description : ""}
                error={errors.instance_description ? true : false}
              />
            </Grid>
            <Grid
              className={classes.projectsettingGrid}
              xs={12}
              sm={12}
              md={12}
              lg={12}
              xl={12}
            >
              <Typography gutterBottom component="div">
                Dataset_Type *:
              </Typography>
            </Grid>
            <Grid item xs={12} md={12} lg={12} xl={12} sm={12}>
              <MenuItems
                menuOptions={type}
                handleChange={(value) => setDatasettype(value)}
                value={datasettype}
                helperText={errors.dataset_type ? errors.dataset_type : ""}
                error={errors.dataset_type ? true : false}
              />
            </Grid>
            <Grid
              className={classes.projectsettingGrid}
              xs={12}
              sm={12}
              md={12}
              lg={12}
              xl={12}
            >
              <Typography gutterBottom component="div">
                {translate("Organization")} *:
              </Typography>
            </Grid>
            <Grid item xs={12} md={12} lg={12} xl={12} sm={12}>
              {/* Раньше здесь вводили числовой id организации вручную.
                  Список подставляется сам; если организация одна — она
                  сразу выбрана. */}
              <MenuItems
                menuOptions={organisationOptions}
                handleChange={(value) => setOrganisation_Id(value)}
                value={organisation_Id}
                helperText={errors.organisation_id ? errors.organisation_id : ""}
                error={errors.organisation_id ? true : false}
              />
            </Grid>
            {/* Поле «User» убрано: это владелец датасета, и он всегда равен
                тому, кто создаёт. Подставляется автоматически. */}
            <Grid
              className={classes.projectsettingGrid}
              style={{}}
              item
              xs={12}
              md={12}
              lg={12}
              xl={12}
              sm={12}
              sx={{ mt: 3 }}
            >

              <Button
                style={{ margin: "0px 20px 0px 0px" }}
                label={translate("Confirm")}
                onClick={handleCreate}
                disabled={ ( instance_Name && datasettype && organisation_Id  ) ? false : true}

              />

              <Button
                label={translate("Cancel")}
                onClick={() => navigate(`/datasets/`)}
              />
            </Grid>
            {renderSnackBar()}
          </Grid>
        </Card>
      </Grid>

      {/* </Grid>
              </Grid> */}
    </ThemeProvider>
  );
};

export default CollectionProject;
